import api from "./api";

class SegmentoAPI {
  async getSegmentosItensEmGatilhoDeCompra(headers, params) {
    return await api.get("/compras_get_segmentos_gatilho_compra", {headers, params});
  }

  async getSegmentosDrp(headers, params) {
    return await api.get("/drp/segmentos", {headers, params});
  }

  async getCategoriasProduto(headers) {
    return await api.get("/produto/categorias", {headers});
  }

  async buscarDepartamentosComprador(headers) {
    return await api.get("/produto/segmentos", {headers});
  }
}

export default new SegmentoAPI();
